import axios from "axios";
import { genUserBaseUrl, businessAccountBaseUrl, rubiesBaseUrl} from "../app.config";
import store from "../store/store";
import swal from "sweetalert";
import router from "../router";
const apiClient = axios.create({
  baseURL: genUserBaseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
const apiClient2 = axios.create({
  baseURL: businessAccountBaseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

apiClient2.interceptors.request.use(config => {
  const token = store.getters.getToken;
  const tok = store.getters["auth/getTok"];
  config.headers.Authorization = (tok == null)? token: tok;
  return config
});

// eslint-disable-next-line no-unused-vars
apiClient2.interceptors.response.use(config => {
  if (config != null)
    if (config.data != null)
      if (config.data.responseCode === '999' || config.data.responsecode === '999'){
        swal('Session Expired!',config.data.responsemessage != null?config.data.responsemessage:config.data.responseMessage,'info').then(res=>{
          localStorage.clear();
          console.log(res)
          router.push('/').then()
        })
      }
  return config
});


const apiClient3 = axios.create({
  baseURL: rubiesBaseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
// https://cors-anywhere.herokuapp.com



export default {
  callLogonApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient2.post("login", payload);
  },
  callLogoutApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("genLogout", payload);
  },
  callInitiateEnrollmentApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient2.post("enrollmentInitiate", payload);
  },
  callCompleteEnrollmentApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient2.post("enrollmentComplete", payload);
  },
  callInitiateResetPasswordApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient3.post("resetpassword", payload);
  },
  callCompleteResetPasswordApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient3.post("resetpasswordcomplete", payload);
  },
  callAuthorize2faApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("v2authenticate", payload);
  },
  callGenerate2faApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("v2generateEnrollmentCode", payload);
  },
  callCheck2faApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("v2checkFor2fa", payload);
  },
  callInitiateRecoverPhoneApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("v2checkFor2fa", payload);
  },
  callCompleteRecoverPhoneApi(payload) {
    // console.log("Service Payload ==>>", payload)
    return apiClient.post("v2checkFor2fa", payload);
  },
};
